























































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { FormItem, Input, Select, Option } from 'element-ui';
import CollapseCard from '@/components/layout/CollapseCard.vue';
import currencies from '@/constants/currencyOptions';
// Types
import {
  BillItemFields,
  BillItemInput,
  TaxTypeEnum
} from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';
// Contants
import { containerSizes } from '@/constants/containerSize';

@Component({
  components: {
    CollapseCard,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option
  }
})
export default class ExtraBillItems extends Vue {
  @Prop({ required: true, type: String }) inquiryId!: string;
  @Prop({ required: true, default: () => [] }) extraBillItems!: BillItemFields[];

  private billItemInputs: BillItemInput[] = [];
  private currenciesOptions: SelectOption<string>[] = currencies();

  @Watch('extraBillItems', { immediate: true })
  private convertToInput(billItems: BillItemFields[]) {
    this.billItemInputs = billItems.map((bi: BillItemFields, index: number): BillItemInput => {
      return {
        id: bi.id,
        shipmentId: bi.shipmentId,
        description: bi.description,
        currency: bi.currency,
        category: bi.category,
        unitPrice: bi.unitPrice,
        cost: bi.cost,
        quantity: bi.quantity,
        taxType: bi.taxType,
        taxRate: bi.taxRate,
        order: index
      };
    });
    this.$emit('extraBillItemSet', this.billItemInputs);
  }

  @Watch('billItemInputs', { deep: true })
  private billItemInputsSet(inputs: BillItemInput[]) {
    this.$emit('extraBillItemSet', inputs);
  }

  private removeBillItem(index: number) {
    this.$delete(this.billItemInputs, index);
  }

  private addBillItem() {
    this.billItemInputs.push({
      shipmentId: this.inquiryId,
      description: '',
      currency: 'JPY',
      unitPrice: 0,
      cost: 0,
      quantity: 1,
      taxType: TaxTypeEnum.no_tax,
      order: this.billItemInputs.length
    });
  }
}
